"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRIGGERS = void 0;
const TRIGGERS = exports.TRIGGERS = [{
  label: 'immediately',
  value: 'immediately'
}, {
  label: 'on exit',
  value: 'on_exit'
}, {
  label: 'time passed',
  value: 'time_passed'
}, {
  label: 'percent scrolled',
  value: 'percent_scrolled'
}];